module.exports = __webpack_public_path__ + "media/images/illustrations/forklift-6881b944152234e8caadf05c2d310ee7.svg";